import React, { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification, Row, Col } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, FilePdfFilled } from "@ant-design/icons";

const { Text } = Typography;

const CreditList = ({ history }) => {
	const [loading, setLoading] = useState(false);
	const [creditList, setCreditList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			render: (_, record) => {
				return (
					<Row gutter={16}>
						<Col>
							<Button
								type="primary"
								danger
								icon={<FilePdfFilled twoToneColor={"white"} />}
								onClick={(e) => history.push(`/credit/pdf/${record.id}`)}
							/>
						</Col>
					</Row>
				);
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "BusinessType",
			dataIndex: "businessType",
			key: "businessType",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getCreditList();
	}, []);

	const getCreditList = async () => {
		setLoading(true);

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/credit/get/list`;

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						customer: item.applicant.name,
						businessType: item.businessType,
						address: `${item.address} ${item.city} ${item.county} ${item.state} ${item.zip}`,
					});
				});
				setCreditList(list);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return <CustomTable columns={columns} data={creditList} isScroll={true} />;
	};

	return (
		<Layout title="Credit List" description="Credit Application">
			{contextHolder}
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default CreditList;
